<template>
  <div class="account-settings-info-view">
    <a-form @submit="handleSubmit">
      <a-form-item>
        <div class="ant-upload-preview" @click="$refs.modal.edit(1)" >
          <a-icon type="cloud-upload-o" class="upload-icon"/>
          <div class="mask">
            <a-icon type="plus" />
          </div>
          <img :src="form.avatar ? globalUrl + form.avatar : '/avatar.png'"/>
        </div>
        <!-- <avatar-view @click="$refs.modal.edit(1)" :img="form.avatar ? form.avatar : '/avatar.png'" /> -->
      </a-form-item>
      <a-form-item label="昵称">
        <a-input
          placeholder="请输入用户昵称"
          name="name"
          v-model="form.name"
        />
      </a-form-item>

      <a-form-item>
        <a-button type="primary" :loading="formLoad" html-type="submit">更新基本信息</a-button>
      </a-form-item>
    </a-form>
    <avatar-modal ref="modal" @ok="setavatar" />
  </div>
</template>

<script>
import { requestPut } from '@/api/api'
import AvatarModal from './AvatarModal'

export default {
    name: 'BaseSetting',
    components: {
        AvatarModal
    },
    data () {
        return {
            id: this.$store.getters.userId,
            form: {
                name: this.$store.getters.name,
                avatar: this.$store.getters.avatar ?? '/avatar.png'
            },
            formLoad: false,
            rules: {
                name: [{}],
                avatar: [{}]
            },
            // cropper
            preview: {},
            option: {
                img: this.$store.getters.avatar ?? '/avatar.png',
                info: true,
                size: 1,
                outputType: 'jpeg',
                canScale: false,
                autoCrop: true,
                // 只有自动截图开启 宽度高度才生效
                autoCropWidth: 180,
                autoCropHeight: 180,
                fixedBox: true,
                // 开启宽度和高度比例
                fixed: true,
                fixedNumber: [1, 1]
            }
        }
    },
    mounted () {
    },
    methods: {
        /**
         * 获取上传头像回调地址
         * @jdy
         * @2020-11-10
         */
        setavatar (avatar) {
            console.log(avatar)
            this.form.avatar = avatar
            this.option.img = this.globalUrl + avatar
        },
        handleSubmit (e) {
            e.preventDefault()
            this.formLoad = true
            requestPut('/admins/users/' + this.id, this.form)
                .then(res => {
                    this.$notification.success({
                        message: res.msg
                    })
                })
                .finally(() => {
                    this.formLoad = false
                })
        }
    }
}
</script>

<style lang="less" scoped>
.avatar-upload-wrapper {
    height: 200px;
    width: 100%;
}

.ant-upload-preview {
    position: relative;
    margin: 0 auto;
    width: 100%;
    max-width: 180px;
    border-radius: 50%;
    box-shadow: 0 0 4px #ccc;

    .upload-icon {
        position: absolute;
        top: 0;
        right: 10px;
        font-size: 1.4rem;
        padding: 0.5rem;
        background: rgba(222, 221, 221, 0.7);
        border-radius: 50%;
        border: 1px solid rgba(0, 0, 0, 0.2);
    }
    .mask {
        opacity: 0;
        position: absolute;
        background: rgba(0, 0, 0, 0.4);
        cursor: pointer;
        transition: opacity 0.4s;

        &:hover {
            opacity: 1;
        }

        i {
            font-size: 2rem;
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -1rem;
            margin-top: -1rem;
            color: #d6d6d6;
        }
    }

    img,
    .mask {
        width: 100%;
        max-width: 180px;
        height: 100%;
        border-radius: 50%;
        overflow: hidden;
    }
}
</style>
